import React from 'react'
import { Card, CardBody, Row, Col } from 'reactstrap'
import { Agenda as MgtAgenda, Tasks as MtgTasks } from '@microsoft/mgt-react'
import { Link } from 'react-router-dom'
import moment from 'moment'

export default function () {
  return (
    <Card>
      <CardBody>
        <Row className="d-flex justify-content-between">
          <Col>
            <h4 className="card-title mb-4">Agenda</h4>
          </Col>
          <Col className="d-flex justify-content-end">
            {/* <a
              target="_blank"
              rel="noreferrer"
              href="https://outlook.office365.com/calendar/view/workweek"
            >
              Ver tudo
            </a> */}
            <Link to="/agenda">
              Ver tudo
            </Link>
          </Col>
        </Row>
        <MgtAgenda
          // renderLocation
          groupByDay={false}
          days={30}
          showMax={3}
          // eventQuery={`/me/events?$filter=start/dateTime ge '${moment()}'&orderby=start/dateTime`}
        />
      </CardBody>
    </Card>
  )
}
